import { ActionCreator, createReducer, on, ReducerTypes } from '@ngrx/store';
import { asyncStoreItemAdapter } from 'src/lib';
import * as actions from './get-standby-travelers-result.actions';
import { GetStandbyTravelersResultState } from './get-standby-travelers-result.state';

/**
 * getStandbyTravelersResult initial state
 */
export const getStandbyTravelersResultInitialState: GetStandbyTravelersResultState = {
  model: null,
  requestIds: [],
};

/**
 * List of basic actions for GetStandbyTravelersResult Store
 */
export const getStandbyTravelersResultReducerFeatures: ReducerTypes<GetStandbyTravelersResultState, ActionCreator[]>[] =
  [
    on(actions.setGetStandbyTravelersResult, (state, payload) =>
      asyncStoreItemAdapter.resolveRequest(
        { ...asyncStoreItemAdapter.extractAsyncStoreItem(state), ...payload },
        payload.requestId
      )
    ),

    on(actions.updateGetStandbyTravelersResult, (state, payload) =>
      asyncStoreItemAdapter.resolveRequest({ ...state, ...payload }, payload.requestId)
    ),

    on(actions.resetGetStandbyTravelersResult, () => getStandbyTravelersResultInitialState),

    on(actions.cancelGetStandbyTravelersResultRequest, (state, action) =>
      asyncStoreItemAdapter.resolveRequest(state, action.requestId)
    ),

    on(actions.failGetStandbyTravelersResult, (state, payload) =>
      asyncStoreItemAdapter.failRequest(state, payload.requestId)
    ),

    on(actions.setGetStandbyTravelersResultFromApi, actions.updateGetStandbyTravelersResultFromApi, (state, payload) =>
      asyncStoreItemAdapter.addRequest(state, payload.requestId)
    ),
  ];

/**
 * GetStandbyTravelersResult Store reducer
 */
export const getStandbyTravelersResultReducer = createReducer(
  getStandbyTravelersResultInitialState,
  ...getStandbyTravelersResultReducerFeatures
);
